/** 设备处分分页与人工解封；缓存按 App、设备与状态隔离，解封后读取后台真实状态。 */
import {
  type DeviceSanctionResponse,
  ReleaseDeviceSanctionRequestSchema,
} from '@novel-admin/shared';
import { onlineManager, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRequest, apiRequestOffsetPaged } from '~/api/client';

export function useDeviceSanctions(appId: string, deviceId: string, status: string, page: number) {
  return useQuery({
    queryKey: ['device-sanctions', appId, deviceId, status, page],
    refetchOnMount: 'always',
    staleTime: 0,
    queryFn: () =>
      apiRequestOffsetPaged<DeviceSanctionResponse>({
        method: 'GET',
        path: '/api/v1/device-sanctions',
        query: {
          page,
          limit: 20,
          ...(appId === 'all' ? {} : { app_id: appId }),
          ...(deviceId.trim() ? { device_id: deviceId.trim() } : {}),
          ...(status ? { status } : {}),
        },
      }),
  });
}

export function useReleaseDeviceSanction() {
  const client = useQueryClient();
  return useMutation({
    // 解封是当前人工决定，不能离线排队或自动重试到运营关闭弹窗之后。
    networkMode: 'always',
    retry: false,
    mutationFn: ({
      id,
      reason,
      expected_revision,
    }: { id: string; reason: string; expected_revision: string }) => {
      if (!onlineManager.isOnline())
        throw new Error('网络不可用，本次解封未发送；恢复后请重新核验并提交。');
      return apiRequest<DeviceSanctionResponse>({
        method: 'POST',
        path: `/api/v1/device-sanctions/${id}/release`,
        body: ReleaseDeviceSanctionRequestSchema.parse({ reason, expected_revision }),
      });
    },
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: ['device-sanctions'] });
    },
  });
}
